import React, { useState, useEffect } from 'react';
import AuthService from './services/AuthService';
import { ROUTE } from './constant';
import { constants } from './constant/constant';

function AutoLogout() {
  // 30 Min
  const [signoutTime] = useState(constants.INACTIVITY_TIME);
  let logoutTimeout;

  const logout = () => {
    if (AuthService.isLoggedIn()) {
      AuthService.signOut();
      window.location.href = ROUTE.ROOT;
    }
  };

  const setTimeouts = () => {
    logoutTimeout = setTimeout(logout, signoutTime);
  };

  const clearTimeouts = () => {
    if (logoutTimeout) clearTimeout(logoutTimeout);
  };

  useEffect(() => {
    const events = [
      'load',
      'mousemove',
      'mousedown',
      'click',
      'scroll',
      'keypress',
    ];

    const resetTimeout = () => {
      clearTimeouts();
      setTimeouts();
    };

    /* for (const i in events) {
      window.addEventListener(events[i], resetTimeout);
    } */

    Object.keys(events).forEach((key) => {
      window.addEventListener(events[key], resetTimeout);
    });

    setTimeouts();
    return () => {
      /* for (const i in events) {
        window.removeEventListener(events[i], resetTimeout);
        clearTimeouts();
      } */

      Object.keys(events).forEach((key) => {
        window.removeEventListener(events[key], resetTimeout);
        clearTimeouts();
      });
    };
  });
  return (
    <div />
  );
}
export default AutoLogout;
